var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparkles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6852 23L13.5309 20.02C12.8364 18.2358 11.3691 16.8252 9.49088 16.1619L6.37039 15.0596L9.49088 13.9573C11.3593 13.294 12.8364 11.8928 13.5309 10.0992L14.6852 7.11922L15.8395 10.0992C16.534 11.8835 18.0013 13.294 19.8795 13.9573L23 15.0596L19.8795 16.1619C18.0111 16.8252 16.534 18.2264 15.8395 20.02L14.6852 23Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39217 10.3888L4.78568 8.81005C4.42374 7.86655 3.64117 7.11922 2.65318 6.77358L1 6.1944L2.65318 5.61521C3.64117 5.26957 4.42374 4.52224 4.78568 3.57874L5.39217 2L5.99867 3.57874C6.3606 4.52224 7.14317 5.26957 8.13117 5.61521L9.78435 6.1944L8.13117 6.77358C7.14317 7.11922 6.3606 7.86655 5.99867 8.81005L5.39217 10.3888Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkles);
export default __webpack_public_path__ + "static/media/sparkles.52f5680644e686e1792327b7f6067fde.svg";
export { ForwardRef as ReactComponent };